<template>
  <table class="is-fullwidth is-opening-hours table text-prose">
    <tbody>
      <tr v-for="row in props.rows" :key="row.day">
        <th>{{ row.name }}</th>
        <td>
          <div>
            <template v-if="row.slots.length === 0">
              <div>{{ $texts('openingHoursClosed', 'Closed') }}</div>
            </template>
            <template v-else>
              <div
                v-for="(slot, index) in row.slots"
                :key="row.name + index"
                v-html="formatTimeRange(slot.start, slot.end)"
              />
            </template>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts" setup>
import type { WeekdayTableRow } from './types'

const props = withDefaults(
  defineProps<{
    rows?: WeekdayTableRow[]
  }>(),
  {
    rows: () => [],
  },
)

const language = useCurrentLanguage()
const { $texts } = useEasyTexts()

function formatTimeRange(from: string, to: string) {
  if (language.value === 'en') {
    return concatTimes(formatEnglishTime(from), formatEnglishTime(to))
  } else if (language.value === 'fr') {
    return concatTimes(formatFrenchTime(from), formatFrenchTime(to))
  } else if (language.value === 'it') {
    return concatTimes(formatItalianTime(from), formatItalianTime(to))
  }
  return concatTimes(formatGermanTime(from), formatGermanTime(to)) + '&nbsp;Uhr'
}

function formatFrenchTime(time: string) {
  return time.replace(':', 'h').replace('h00', 'h')
}

function formatItalianTime(time: string) {
  return time.replace(':', '.')
}

function formatGermanTime(time: string) {
  return time.replace(':', '.')
}

function formatEnglishTime(time: string) {
  const [h = '0', m = '00'] = time.split(':')
  const suffix = parseInt(h) >= 12 && parseInt(h) < 24 ? 'pm' : 'am'
  const hours = parseInt(h) % 12
  return [hours === 0 ? 12 : hours, m].join('.') + suffix
}

function concatTimes(from: string, to: string): string {
  return [from, to].join('&nbsp;– ')
}
</script>

<style lang="postcss" scoped>
.table.is-opening-hours {
  th {
    @apply pl-0;
  }
  th {
    @screen tablet {
      width: 33%;
    }
  }
  td > div {
    @apply tablet:flex;
    > div {
      @apply tablet:flex-1;
    }
  }
}
</style>
